import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import {
  dateNowUnix,
  epochStoMs,
  diffInDays,
  dateNow,
  dateToUnix,
  TZ,
  formatDate,
  formatLocaleDate,
} from "../utils/dateUtils";
import ja from "dayjs/locale/ja";

/**
 * Checks if purchase list is expired
 * @param {number} expiry
 * @returns if is expired
 */
function hasExpired(expiry: number) {
  var dateNow = dateNowUnix();
  var expiryDate = expiry;
  if (!dayjs().tz(TZ.JST).isBefore(dayjs(expiryDate))) {
    return true;
  }
  return false;
}
/**
 * Check if purchase list has less than a month to expire
 * @param {number} support
 * @returns string
 */
function lessThanAMonth(support: number) {
  var DateNow = dateNowUnix();
  var supportDate = support * 1000;
  var differenceInDays = diffInDays(DateNow, supportDate, true);
  if (differenceInDays < 30 && differenceInDays >= 0) {
    return "show30dayButton";
  }
}
/**
 * Check if purchase list has less than two weeks to expire
 * @param {number} expiry
 * @returns difference in days
 */
function lessThanTwoWeeks(expiry: number) {
  var differenceInDays = diffInDays(dateToUnix(expiry), dateNow(), true);
  if (differenceInDays < 15 && differenceInDays >= 0) {
    return differenceInDays;
  } else {
    return false;
  }
}
export function minutesLeftTillSupport(date) {
  const currentTime = dayjs().tz(TZ.JST).locale(ja);
  const differenceInMinutes = dayjs(date).diff(currentTime, "minute");
  return differenceInMinutes > 30;
}
function listOfTwoWeeks() {
  const today = dayjs();
  const twoWeeksFromNow = today.add(2, "week");
  const dateList: any[] = [];

  let currentDate = today;
  var idx = 0;
  while (currentDate.isBefore(twoWeeksFromNow)) {
    var month = currentDate.tz(TZ.JST).locale(ja).format("M");
    var day = currentDate.tz(TZ.JST).locale(ja).format("D");
    var dayName = currentDate.tz(TZ.JST).locale(ja).format("dd");
    if (currentDate == today) {
      dayName = "今日";
    }
    if (idx == 1) {
      dayName = "明日";
    }
    var obj = {
      date: currentDate.tz(TZ.JST).locale(ja).format("M月D日 (dd)"),
      dateYear: currentDate.tz(TZ.JST).locale(ja).format("YYYYMMDD"),
      month: month,
      day: day,
      dayName: dayName,
    };
    dateList.push(obj);
    currentDate = currentDate.add(1, "day");
    idx++;
  }
  return dateList;
}

export function printDateTime(date) {
  var arr = date.split("-");
  var localeDate = formatLocaleDate(arr[1]);
  var time = arr[2] + ":" + arr[3];
  var dateTime = localeDate + time;
  return dateTime;
}
export function isDateFromFuture(ymdhhmm) {
  const today = dayjs().tz(TZ.JST).locale(ja);
  const givenDate = dayjs(ymdhhmm);
  return givenDate.isAfter(today);
}
export function listOfThreeWeeks() {
  const today = dayjs();
  const threeWeeksFromNow = today.add(3, "week");
  const dateList: any[] = [];

  let currentDate = today;
  var idx = 0;
  while (currentDate.isBefore(threeWeeksFromNow)) {
    var year = currentDate.tz(TZ.JST).locale(ja).format("YYYY-MM-DD");
    var month = currentDate.tz(TZ.JST).locale(ja).format("M");
    var day = currentDate.tz(TZ.JST).locale(ja).format("D");
    var dayName = currentDate.tz(TZ.JST).locale(ja).format("dd");
    var week = currentDate.tz(TZ.JST).locale(ja).format("d");
    var obj = {
      year: year,
      date: currentDate.tz(TZ.JST).locale(ja).format("M月D日 (dd)"),
      dateYear: parseInt(currentDate.tz(TZ.JST).locale(ja).format("YYYYMMDD")),
      month: month,
      day: day,
      week: week,
      dayName: dayName,
    };
    dateList.push(obj);
    currentDate = currentDate.add(1, "day");
    idx++;
  }
  return dateList;
}
export { lessThanAMonth, lessThanTwoWeeks, hasExpired, listOfTwoWeeks };
